/**
 * Minimal semver comparator for the browser side.
 * Returns -1 if a < b, 0 if equal, 1 if a > b.
 * Handles numeric ordering: 1.2.3 < 1.10.0.
 * Malformed → 0 (equal, don't crash).
 *
 * Deliberately duplicated from nyc-bridge/src/compareVersions.ts —
 * separate packages that can't share imports.
 */
export function compareVersions(a, b) {
  const pa = String(a).split(".").map(Number);
  const pb = String(b).split(".").map(Number);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const na = pa[i] ?? 0;
    const nb = pb[i] ?? 0;
    if (!Number.isFinite(na) || !Number.isFinite(nb)) return 0;
    if (na < nb) return -1;
    if (na > nb) return 1;
  }
  return 0;
}
